import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { AuthContext } from '../../../../context/AuthContext';
import { updateUserPreferences } from '../../../../firebase/services';
import './settings.css';

const LANGUAGES = [
  { code: 'en', label: 'English', beta: false },
  { code: 'es', label: 'Español', beta: true },
  { code: 'ko', label: '한국어', beta: true },
  { code: 'zh-CN', label: '简体中文', beta: true },
];

const LanguageScreen = () => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const { currentUser } = useContext(AuthContext);

  const handleLanguageSelect = async (code) => {
    // Change language immediately
    i18n.changeLanguage(code);

    // Persist to Firestore
    if (currentUser) {
      try {
        await updateUserPreferences(currentUser.uid, { language: code });
      } catch (error) {
        console.warn('Failed to save language preference:', error.message);
      }
    }
  };

  return (
    <div className="settings-screen">
      <header className="settings-header">
        <button onClick={() => navigate('/profile')} className="back-button">
          &larr;
        </button>
        <h1>{t('language.title')}</h1>
      </header>
      <main className="settings-content">
        <div className="settings-pref-card">
          {LANGUAGES.map((lang) => {
            const isActive = i18n.language === lang.code ||
              (lang.code === 'en' && !LANGUAGES.some(l => l.code === i18n.language));
            return (
              <button
                key={lang.code}
                onClick={() => handleLanguageSelect(lang.code)}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  width: '100%',
                  padding: '14px 16px',
                  background: isActive ? 'rgba(255, 209, 0, 0.08)' : 'transparent',
                  border: 'none',
                  borderBottom: '1px solid #eee',
                  cursor: 'pointer',
                  fontFamily: 'inherit',
                  textAlign: 'left'
                }}
              >
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <span style={{ fontSize: '15px', fontWeight: isActive ? '600' : '400', color: '#1a3a5c' }}>
                    {lang.label}
                  </span>
                  {lang.beta && (
                    <span style={{
                      fontSize: '10px',
                      fontWeight: '600',
                      color: '#888',
                      background: '#f0f0f0',
                      padding: '2px 6px',
                      borderRadius: '4px',
                      letterSpacing: '0.5px'
                    }}>
                      Beta
                    </span>
                  )}
                </div>
                {isActive && (
                  <span style={{ fontSize: '12px', color: '#888', fontWeight: '500' }}>
                    {t('language.current')}
                  </span>
                )}
              </button>
            );
          })}
        </div>

        <p style={{
          fontSize: '12px',
          color: '#999',
          lineHeight: '1.5',
          marginTop: '12px',
          padding: '0 4px'
        }}>
          {t('language.betaNote')}
        </p>
      </main>
    </div>
  );
};

export default LanguageScreen;
